import classNames from 'classnames';
import { autobind } from 'core-decorators';
/* eslint-disable max-len */
import PropTypes from 'prop-types';
import { Component } from 'react';
import ControlApplications from '/@/components/control-applications';
import Tabs from '/@/components/tabs';
import settings from '/@/core/settings';
import { _, _lazy } from '/@/locale';
import styles from './styles.module.css';

@autobind
export default class WeedControl extends Component {
    static propTypes = {
        className: PropTypes.string,
        classNameWeedControl: PropTypes.string,
    };

    static label = _lazy('Control de malezas');
    static icon = 'weeds';

    static contextTypes = {
        print: PropTypes.bool,
    };

    state = {
        selectedTab: 'main',
    };

    getConfigs(wcp, system) {
        const { applications } = wcp;
        const configs = [
            {
                tab: { value: 'secondary', label: _(system?.[0]?.secondaryCrop) },
                type: 'previous',
                crop: system?.[0]?.secondaryCropCodename,
            },
            {
                tab: { value: 'main', label: _(system?.[0]?.mainCrop) },
                type: 'main',
                crop: system?.[0]?.mainCropCodename,
            },
        ];

        /*if (system.secondaryCropCodename === crop) { // Invert configuration
            configs = [
                { tab: { value: 'main', label: _(system?.[0]?.secondaryCrop) }, type: 'previous', crop: system?.[0]?.secondaryCropCodename },
                { tab: { value: 'secondary', label: _(system?.[0]?.mainCrop) }, type: 'main', crop: system?.[0]?.mainCropCodename },
            ];
        }*/

        return configs
            .map(({ tab, type }) => ({
                tab,
                applications: applications.filter((application) => application.type === type),
            }))
            .filter(({ applications }) => !!applications.length);
    }

    renderTabs(config) {
        const tabs = config.map(({ tab }) => tab);
        if (tabs.length < 2) return null;
        return (
            <Tabs
                theme={settings.app.theme}
                tabs={tabs}
                selected={this.state.selectedTab}
                onChange={(selectedTab) => this.setState({ selectedTab })}
            />
        );
    }

    valueOfIcon(label, identifier) {
        if (label.includes('Soja')) {
            return identifier === 'planting' ? 'plantingSoy' : 'vegetativeSoy';
        }
        if (label.includes('Milho' || 'Maíz')) {
            return identifier === 'planting' ? 'plantingCorn' : 'vegetativeCorn';
        }
        if (label.includes('Algodão')) {
            return identifier === 'planting' ? 'plantingCotton' : 'vegetativeCotton';
        }
    }

    renderApplications(config) {
        const { print } = this.context;
        const { selectedTab } = this.state;

        if (!config.applications.length) return null;
        if (selectedTab !== config.tab.value && !print) return null;
        const data = config.applications.map((application) => {
            const windows = _(application.products)
                .split(/^- |\n- /)
                .filter(Boolean)
                .map((group) => {
                    const [title, ...items] = group.split(/\n-- /);
                    return { title, items };
                });
            const stage = settings.enums.cropStages[application.stage];
            const addCropToIcon = ['planting', 'vegetative'].includes(stage.identifier);
            const valueOfIcon = this.valueOfIcon(config.tab.label, stage.identifier);
            const icon = addCropToIcon ? `${valueOfIcon}` : stage.identifier;

            return { title: stage.label, icon, windows };
        });

        return (
            <div key={config.tab.value} className={styles.applications}>
                {print && <div className={styles.title}>{_(config.tab.label)}</div>}
                <ControlApplications data={data} />
            </div>
        );
    }

    renderNotes(notes) {
        if (!notes.length) return null;

        return (
            <div className={styles.notes}>
                <div className={styles.title}>{_('Notas')}</div>
                <ul>
                    {notes.map((note) => (
                        <li key={note.id}>
                            {note.order}. <span className={styles.italic}>{_(note.text)}</span>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }

    render() {
        const { print } = this.context;
        const { system, weedControlPlan, className, classNameWeedControl } = this.props;
        const configs = this.getConfigs(weedControlPlan, system);

        return (
            <div className={classNames(styles.root, className)}>
                <div className={classNameWeedControl}>
                    {!print && this.renderTabs(configs)}
                    {configs.map(this.renderApplications)}
                    {this.renderNotes(weedControlPlan.notes)}
                </div>
            </div>
        );
    }
}
